export default __webpack_public_path__ + "public/images/bg_notify_success.png";